import { HcsAnnContactDtoIds } from '@toktokdoctech/tokapi-client'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import { useNavigate } from 'react-router-dom'
import TokTokDocDataTable from '../../Common/DataTable'
import DataTableActions from '../../Common/dataTableActions/DataTableActions'
import { ContactsDataTableProps } from './_props'

const ContactsDataTable = ({
    page,
    itemsPerPage,
    count,
    handlePaginationChange,
    handleItemsPerPageChange,
    loading,
    data: contacts,
}: ContactsDataTableProps) => {
    const navigate = useNavigate()

    const getHeaders = () => [
        {
            label: 'Nom',
        },
        {
            label: 'Prénom',
        },
        {
            label: 'Profession',
        },
        {
            label: 'Spécialité',
        },
        {
            label: 'Actions',
            size: 'sm' as const,
            orientation: 'center' as const,
        },
    ]

    const describeRows = (row: HcsAnnContactDtoIds) => [
        {
            item: row.lastName,
        },
        {
            item: row.firstName,
        },
        {
            item: row.profession,
        },
        {
            item: row.speciality,
        },
        {
            item: (
                <DataTableActions
                    actions={[
                        {
                            to: `/contact/${row?.id}`,
                            icon: (
                                <EditRoundedIcon
                                    data-cy="editIcon"
                                    fontSize="small"
                                    titleAccess="Modifier un correspondant"
                                />
                            ),
                        },
                    ]}
                />
            ),
            orientation: 'center' as const,
        },
    ]

    return (
        <TokTokDocDataTable
            loading={loading}
            page={page}
            itemsPerPage={itemsPerPage}
            count={count}
            handlePaginationChange={handlePaginationChange}
            handleItemsPerPageChange={handleItemsPerPageChange}
            headers={getHeaders()}
            items={contacts}
            describeRows={describeRows}
            onRowClick={(row) => navigate(`/contact/${row?.id}`)}
        />
    )
}

export default ContactsDataTable
